export default __webpack_public_path__ + "static/media/cliente04_color.4fd8e476.png";